import { Injectable } from '@angular/core';
import { Store } from '@ngrx/store';
import { Observable } from 'rxjs';
import * as ChildDeactivationActions from './child-deactivation.actions';
import {
  selectChildDeactivationActionInProgressId,
  selectChildDeactivationError,
  selectChildDeactivationLoading,
  selectChildDeactivationRequests,
  selectResolvedChildDeactivationRequests
} from './child-deactivation.selectors';
import { AppState } from '../app.reducer';
import { ChildDeactivationRequest } from '@core/models/domain/child-deactivation.domain';
import {
  DeclineChildDeactivationRequest,
  ExemptChildDeactivationRequest
} from '@core/models/request/child-deactivation.request';

@Injectable({ providedIn: 'root' })
export class ChildDeactivationStoreFacade {
  requests$: Observable<ChildDeactivationRequest[]> = this.store.select(selectChildDeactivationRequests);
  resolvedRequests$: Observable<ChildDeactivationRequest[]> = this.store.select(selectResolvedChildDeactivationRequests);
  loading$: Observable<boolean> = this.store.select(selectChildDeactivationLoading);
  error$: Observable<string | null> = this.store.select(selectChildDeactivationError);
  actionInProgressId$: Observable<string | null> = this.store.select(selectChildDeactivationActionInProgressId);

  constructor(private store: Store<AppState>) {}

  loadRequests(): void {
    this.store.dispatch(ChildDeactivationActions.loadRequests());
  }

  loadResolvedRequests(): void {
    this.store.dispatch(ChildDeactivationActions.loadResolvedRequests());
  }

  approve(requestId: string): void {
    this.store.dispatch(ChildDeactivationActions.approveRequest({ requestId }));
  }

  decline(request: DeclineChildDeactivationRequest): void {
    this.store.dispatch(ChildDeactivationActions.declineRequest({ request }));
  }

  exempt(request: ExemptChildDeactivationRequest): void {
    this.store.dispatch(ChildDeactivationActions.exemptRequest({ request }));
  }
}
